import React from 'react';
import { DocsContent } from '../Docs/DocsContent';

const TermsOfService = () => {
  const section = {
    title: 'Terms of Service',
    path: '/legal/terms-of-service.md',
  };

  return (
    <div className="container py-4">
      <div className="row">
        <div className="col-12">
          <DocsContent section={section} />
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
